import React from 'react';
import {ProtectedRoute} from '../../_common/components/Permissions';
import UsersActions from '../pages';
import {pathnames as P} from '../../_common/constants/pathnames';
import {subjects as S} from '../../_common/constants/permissionSubjects';

export const usersActionsRoute = (
  <ProtectedRoute
    subject={S.USERS_ACTIONS_PAGE}
    path={P.USERS_ACTIONS_PAGE}
    component={UsersActions}
  />
);
